import { PROVINCES_EXTENDED, TProvinceExtended } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectOptionRenderFn, SelectOptionType } from '../BaseForm';

type Props = {
  value?: TProvinceExtended | TProvinceExtended[];
  onChange?: (value: TProvinceExtended | TProvinceExtended[]) => void;
  optionsRender?: SelectOptionRenderFn<SelectOptionType<TProvinceExtended>>;
  mode?: 'multiple';
  disabled?: boolean;
  placeholder?: string;
};

export const ProvincesExtendedSelector: React.FC<Props> = ({
  value,
  onChange,
  optionsRender,
  mode,
  disabled,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = useMemo(
    () =>
      PROVINCES_EXTENDED.map(province => ({
        label: province,
        value: province
      })).sort((a, b) => a.label.localeCompare(b.label)),
    [PROVINCES_EXTENDED]
  );

  return (
    <Select
      allowClear
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder || t('PROVINCE')}
      style={{ minWidth: '180px' }}
      optionRender={optionsRender}
      mode={mode}
      showSearch
      disabled={disabled}
      filterOption={(input, option) =>
        String(option?.label || '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  );
};
